import type { InboxCounts } from "./api";
import { useInboxCounts } from "./api";

/** The bell's number: "To approve" (approvers only) + unread Updates, from the new counts only (never today's). */
export const bellCount = (c: InboxCounts | undefined): number => (c ? (c.to_approve ?? 0) + c.updates : 0);

/** `enabled`: the user may see notifications at all (the bell is hidden otherwise, so nothing is asked). */
export const useBellCount = (enabled = true): number => bellCount(useInboxCounts({ enabled }).data);
